import store from "../../../store";
import {
  REGISTER_WITH_EMAIL,
  REGISTER_WITH_MOBILE,
} from "../../../utils/constants";
import { getChangeEmailFlow } from "../ChangeEmail/flow";

const MOBILE_LISTING_ROUTE = "/portal/nct/change-mobile";
const MOBILE_ENTER_ROUTE = "/portal/nct/change-mobile-new";
const MOBILE_OTP_VERIFY = "/portal/nct/otp-verification";
const REGISTERED_EMAIL_OR_PHONE_VERIFY = "/portal/nct/change-mobile-auth";

export const SUCCESS = "SUCCESS";

export const MOBILE_LOGIN_FLOW = [
  MOBILE_LISTING_ROUTE,
  REGISTERED_EMAIL_OR_PHONE_VERIFY,
  MOBILE_ENTER_ROUTE,
  MOBILE_OTP_VERIFY,
];
export const EMAIL_LOGIN_FLOW = [
  MOBILE_ENTER_ROUTE,
  MOBILE_OTP_VERIFY,
  MOBILE_LISTING_ROUTE,
  REGISTERED_EMAIL_OR_PHONE_VERIFY,
];

export function getChangeMobileFlow(registerType = REGISTER_WITH_MOBILE) {
  return registerType === REGISTER_WITH_EMAIL
    ? EMAIL_LOGIN_FLOW
    : MOBILE_LOGIN_FLOW;
}

export function nextScreen(path: string, nctFlow: string = "mobile") {
  const { authReducer } = store.getState();
  const { userRegisteredWith } = authReducer;
  const flows =
    nctFlow === "email"
      ? getChangeEmailFlow(userRegisteredWith)
      : getChangeMobileFlow(userRegisteredWith);
  if (!path) {
    return flows[0];
  }
  const index = flows.findIndex((_flow) => _flow === path);
  if (index + 1 === flows.length) {
    return SUCCESS;
  }
  return flows[index + 1];
}
// export function emailRegisteredUser() {
//     const { authReducer } = store.getState();
//     const { userRegisteredWith } = authReducer;
//     return userRegisteredWith === REGISTER_WITH_EMAIL;
// }
